export default "__VITE_ASSET__C9wDKq6E__"